import React, { Component } from 'react';
import PropTypes from 'prop-types';

import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import TextField from '@material-ui/core/TextField';
import Paper from '@material-ui/core/Paper';
import Icon from '@material-ui/core/Icon';

import {
  SearchState,
  IntegratedFiltering,
  SelectionState,
} from '@devexpress/dx-react-grid';
import {
  Grid,
  VirtualTable,
  Toolbar,
  SearchPanel,
  TableHeaderRow,
  TableSelection,
} from '@devexpress/dx-react-grid-material-ui';

import TooltipsTypeProvider from './data_type_provider/TooltipsTypeProvider.js';
import PhoneTypeProvider from './data_type_provider/PhoneTypeProvider.js';
import GenderTypeProvider from './data_type_provider/GenderTypeProvider.js';

import moment from 'moment';

import firebase from 'firebase/app';
require("firebase/firestore");

class CheckInDialog extends Component {
  constructor(props) {
    super(props);
    this.state = {
      open: this.props.open,
      processing: false,

      checkInTime: new Date(),
      userId: null,
      selection: [],

      users: this.props.users,
    };
    this.updateWindowDimensions = this.updateWindowDimensions.bind(this);
  }

  handleSubmit = () => {
    if (this.state.userId && this.state.checkInTime && this.props.branchId) {
      this.startProcessing();
      firebase.firestore()
        .collection('deskTransaction')
        .add({
          branch: this.props.branchId,
          userId: this.state.userId,
          checkInTime: this.state.checkInTime,
          voided: false,
        })
        .then(() => {
          this.stopProcessing();
          this.handleRequestClose();
        });
    }
  }

  startProcessing = () => {
    this.setState({ processing: true });
  }

  stopProcessing = () => {
    this.setState({ processing: false });
  }

  handleRequestClose = () => {
    this.setState({ open: false });
    this.props.onRequestClose();
  };

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.open !== this.state.open) {
      var state = { open: nextProps.open };
      if (nextProps.open) {
        state.checkInTime = new Date();
        state.userId = null;
        state.selection = [];
      }
      this.setState(state);
    }
    if (nextProps.users) {
      this.setState({ users: nextProps.users });
    }
  }

  componentDidMount() {
    this.updateWindowDimensions();
    window.addEventListener('resize', this.updateWindowDimensions);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.updateWindowDimensions);
  }

  updateWindowDimensions() {
    this.setState({ width: window.innerWidth, height: window.innerHeight });
  }

  render() {
    return (
      <Dialog
        maxWidth='lg'
        onClose={this.handleRequestClose}
        open={this.state.open}>
        <DialogTitle>Check-In</DialogTitle>
        <DialogContent>

          <TextField
            fullWidth
            margin="normal"
            inputProps={{ step: 1, }}
            InputLabelProps={{ shrink: true, }}
            label='Check-In Time'
            type="time"
            value={moment(this.state.checkInTime).format('HH:mm:ss')}
            onChange={event => {
              this.setState({ checkInTime: event.target.value ? moment(event.target.value, 'HH:mm:ss').toDate() : null })
            }}
          />

          <Paper style={{ marginTop: '16px' }}>
            <Grid
              getRowId={row => row.id}
              rows={this.state.users}
              columns={[
                { name: 'name', title: 'Name' },
                { name: 'email', title: 'Email' },
                { name: 'phone', title: 'Phone' },
                { name: 'gender', title: 'Gender' },
              ]}>

              <TooltipsTypeProvider for={['name', 'email']} />
              <PhoneTypeProvider for={['phone']} />
              <GenderTypeProvider for={['gender']} />

              <SearchState />
              <IntegratedFiltering />

              <SelectionState
                selection={this.state.selection}
                onSelectionChange={selection => {
                  if (selection.length > 1) {
                    let index = selection.indexOf(this.state.selection[0]);
                    if (index > -1) {
                      selection.splice(index, 1);
                    }
                  }
                  this.setState({ selection: selection, userId: selection[0] });
                }}
              />

              <VirtualTable height={this.state.height - 48 - 48 - 68 - 72 - 16 - 52 - 96} />
              <TableHeaderRow />
              <Toolbar />
              <SearchPanel
                messages={{ searchPlaceholder: "Search by name, email or phone" }}
                inputComponent={({ ...props }) => (
                  <SearchPanel.Input
                    {...props}
                    autoFocus
                    fullWidth />
                )} />
              <TableSelection
                selectByRowClick
                highlightRow
                showSelectionColumn={false}
              />

            </Grid>
          </Paper>

        </DialogContent>

        <DialogActions>
          <Button onClick={this.handleRequestClose} >CLOSE</Button>
          <Button
            disabled={
              this.state.processing ||
              !this.state.userId ||
              !this.state.checkInTime
            }
            onClick={this.handleSubmit}
            color="primary">
            CHECK-IN
            <Icon style={{ marginLeft: 8 }}>chevron_right</Icon>
          </Button>
        </DialogActions>

      </Dialog>
    );
  }
}

CheckInDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  onRequestClose: PropTypes.func.isRequired,
  users: PropTypes.array.isRequired,
  branchId: PropTypes.string,
};

export default CheckInDialog;
